var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[(_vm.$store.getters.banner && _vm.$route.matched.length && _vm.$route.name !== 'Odin' && !_vm.$route.meta.hideBanner)?_c('Banner'):_vm._e(),(_vm.$route.matched.length)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }